import { render, staticRenderFns } from "./ExportPortRegistrationForm.vue?vue&type=template&id=22017708&scoped=true&"
import script from "./ExportPortRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ExportPortRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./ExportPortRegistrationForm.vue?vue&type=style&index=0&id=22017708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22017708",
  null
  
)

export default component.exports